
const apiConfig = {
           baseURL: "https://api.fastbat.co",
        // baseURL: "http://localhost:5000",
};

export default apiConfig;